import RouteUtils from '~/core/utils/RouteUtils';
import {policyPaths} from '~/paths';
import {OKTA_ROLE} from '~/config';

const routes = [
	{
		path: policyPaths.policyDirectDebitPagePattern,
		title: 'Set up/edit Direct Debit details',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/DirectDebitPage');
		}),
	},
	{
		path: policyPaths.policyPaymentsPagePattern,
		title: 'Policy Payments',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PaymentsPage');
		}),
	},
	{
		path: policyPaths.cancelPolicyPagePattern,
		title: 'Cancel Policy',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/CancelPolicyPage');
		}),
	},
	{
		path: policyPaths.policyHistoryPagePattern,
		title: 'Policy History',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyHistoryPage');
		}),
	},
	{
		path: policyPaths.documentsPagePattern,
		title: 'Documents',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/DocumentsPage');
		}),
	},
	{
		path: policyPaths.documentUploadPagePattern,
		title: 'Document Upload',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/DocumentUploadPage');
		}),
	},
	{
		path: policyPaths.policyDetailsPagePattern,
		title: 'Policy Details',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyDetailsPage');
		}),
	},
	{
		path: policyPaths.documentClaimsUploadPage,
		title: 'Claims Document Upload',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ClaimsDocumentUploadPage');
		}),
	},
];

export default routes;
